import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 26, mass: 0.4 });

  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed left-0 right-0 top-0 z-[60] h-[2px] origin-left bg-gold/80"
      style={{ scaleX }}
      aria-hidden="true"
    />
  );
}
